import React from 'react';
import { isIE } from 'react-device-detect';
import Icon, { CustomSizeIcon } from '../components/Icon';
import ColorStyles from '../styles/base/_colors.scss';
import ImageManager from './ImageManager';

export const LeftArrowIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('left_arrow');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon
          type="left_arrow"
          color={ColorStyles.color_dark_purple_1}
          bgColor={ColorStyles.color_white}
        />
      )}
    </div>
  );
};

export const RightArrowIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('right_arrow');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon
          type="right_arrow"
          color={ColorStyles.color_dark_purple_1}
          bgColor={ColorStyles.color_white}
        />
      )}
    </div>
  );
};

export const PlayVideoIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('play');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="play" color={ColorStyles.color_white} />
      )}
    </div>
  );
};

export const AppleIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('apple');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="apple" color={ColorStyles.color_white} />
      )}
    </div>
  );
};

export const InfoIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('info');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon
          type="info"
          color={ColorStyles.color_dark_purple_1}
          bgColor={ColorStyles.color_white}
        />
      )}
    </div>
  );
};

export const CloseIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('close');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon
          type="close"
          color={ColorStyles.color_dark_purple_1}
          bgColor={ColorStyles.color_white}
        />
      )}
    </div>
  );
};

export const DownloadAppleIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('download_apple');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className=" banner_slider--download_apple_IE" src={image} alt={image} />
      ) : (
        <CustomSizeIcon
          width="148"
          height="44"
          type="download_apple"
          color={ColorStyles.color_white}
        />
      )}
    </div>
  );
};

export const FacebookIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('facebook');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="facebook" color={ColorStyles.color_primary_purple} />
      )}
    </div>
  );
};

export const TwitterIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('twitter');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="twitter" color={ColorStyles.color_primary_purple} />
      )}
    </div>
  );
};

export const YoutubeIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('youtube');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="youtube" color={ColorStyles.color_primary_purple} />
      )}
    </div>
  );
};

export const ContractIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('contract');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="contract" color={ColorStyles.color_white} />
      )}
    </div>
  );
};

export const ExpandIcon = (applyClass) => {
  const image = new ImageManager('id', '../').getIconImage('expand');
  return (
    <div className={applyClass}>
      {isIE ? (
        <img className={applyClass} src={image} alt={image} />
      ) : (
        <Icon type="expand" color={ColorStyles.color_white} />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/managers/IconManager.js